<!-- prettier-ignore -->
<div class="breadcrumb-bar">
  <app-breadcrumb
    [titles]="[
      { label: 'レビュー一覧', url: '/hospital/reviews' },
      { label: 'データ種一覧（' + reviewId + '）', url: '/hospital/reviews/' + reviewId + '/data-types' },
      { label: dataName }
    ]"
  ></app-breadcrumb>

  @if (targetHospitalName) {
    <span class="hospital-badge" aria-label="対象施設名">
      {{ targetHospitalName }}
    </span>
  }
</div>

<p class="table-title">{{ dataType }}</p>

<!-- prettier-ignore -->
<div>
  @if (anonymizedStatus === 'loading' && isInitLoading) {
    <app-skeleton type="table" />
    <app-spinner message="読み込み中" />
  }

  @if ((anonymizedStatus === 'success') || !isInitLoading) {
    @if (dataList.length > 0) {
      <div class="view-container"><!-- 幅を統一する親ラッパ -->
        <div class="table-container" [class.tooltip-ready]="tooltipEnabled">
          <table class="responsive-table" #table>
            <caption class="table-description">匿名加工後データ一覧</caption>
            <thead>
              <tr>
                @for (key of tableHeaders; track key; let i = $index) {
                  <th
                    [class.id-col]="key === 'id'"
                    [class.anonyid-col]="key === 'anonymizationid'"
                    [attr.data-col-index]="i"
                    [appResizableColumn]="key === 'id' ? false : true"
                    [index]="i"
                    scope="col"
                  >
                    {{ key }}
                  </th>
                }
              </tr>
            </thead>

            <tbody>
              @for (item of dataList; track item['id'] ?? $index) {
                <tr>
                  @if (tooltipEnabled) {
                    @for (key of tableHeaders; track key; let i = $index) {
                      <td
                        [class.id-col]="key === 'id'"
                        [class.anonyid-col]="key === 'anonymizationid'"
                        [attr.data-col-index]="i"
                        [matTooltip]="key === 'id' ? null : getTooltipText(item, key)"
                        [matTooltipPosition]="'above'"
                        appEllipsis
                      >
                        {{ item[key] }}
                      </td>
                    }
                  } @else {
                    @for (key of tableHeaders; track key; let i = $index) {
                      <td
                        [class.id-col]="key === 'id'"
                        [class.anonyid-col]="key === 'anonymizationid'"
                        [attr.data-col-index]="i"
                      >
                        {{ item[key] }}
                      </td>
                    }
                  }
                </tr>
              }
            </tbody>
          </table>

          @if (anonymizedStatus === 'loading') {
            <app-spinner message="読み込み中" />
          }
        </div>

        @if (anonymizedStatus === 'success' && dataList.length > 0) {
          <app-pagination
            [currentPage]="currentPage"
            [totalPages]="totalPages"
            [itemsPerPage]="itemsPerPage"
            [itemsPerPageOptions]="itemsPerPageOptions"
            (pageChange)="onPageChange($event)"
            (itemsPerPageChange)="onItemsPerPageChange($event)"
          />
        }
      </div>
    } @else {
      <app-skeleton type="table" [messages]="['匿名加工後データが登録されていません']" />
    }
  }

  @if (anonymizedStatus === 'error') {
    <app-skeleton
      type="alert"
      [messages]="['匿名加工後データの取得に失敗しました。','しばらくしてから再度お試しください。']"
    />
  }
</div>
